import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../services/shared.service';
import { FirebaseService } from '../../service/firebase.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-list-selection-modal',
  templateUrl: './list-selection-modal.component.html',
  styleUrls: ['./list-selection-modal.component.scss']
})
export class ListSelectionModalComponent implements OnInit {

  public defaultData: any;
  private selectedData: any = [];

  constructor(public dialogRef: MatDialogRef<ListSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _sharedVar: SharedService, private _firebase: FirebaseService, private _utils: UtilsService) {
    this.getData(data.type);
  }

  ngOnInit() {
  }

  getData(type) {

    //   console.log(this._sharedVar.selectedDevice, type)

    if (type == 'web')
      this._firebase.getModuleFromDevice('kiosk', this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {

        // console.log(d)

        let data = d.data.urlConfig;
        /*     data.id = d.id
             data.forEach(elem => {
               elem.id = d.id;
             })*/
        this.defaultData = data

        // console.log(this.defaultData)
      })

    else if (type == 'quiz') {


      this._firebase.getAllQuizFromDevice(this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
        //  console.log(d)


        this.defaultData = d;
      })


    }
    else if (type == 'folder') {

      console.log(this.data.data, this.data.id)
      this.defaultData = this._utils.getNestedArrayElementWithoutChildren(this.data.data, this.data.id);

      if (!this._firebase.user.assignedDevice || this._firebase.user.enableAllContent)
        this.defaultData.unshift({ name: 'Accueil', root: true })
    }
    else if (type == 'lottery') {
      this._firebase.getModuleFromDevice('lottery', this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
        this.defaultData = d.data.listConfig
      })
    }

  }

  setSelected(item) {

    if (this.data.type == 'folder') {
      this.selectedData = [];
      this.selectedData.push(item)
    }
    else {
      //console.log(item)
      this.defaultData.forEach(elem => {
        if (elem == item) {
          if (elem.selected) {
            elem.selected = false

            //  console.log(item)
            this.selectedData.forEach((a, index, object) => {
              if (a == item)
                object.splice(index, 1)
            })


            /* REMOVE FROM SELECTED LIST */

          } else {
            elem.selected = true;
            this.selectedData.push(item)
          }

        }
      })
    }


    this.data.currentValue = this.selectedData
    // console.log(this.selectedData)

  }

  onNoClick() {
    this.dialogRef.close();
  }

}
